import React from 'react';
import { Result, Button } from 'antd';
import { useTranslation } from 'react-i18next';

interface ErrorStateProps {
  title?: string;
  subtitle?: string;
  onRetry?: () => void;
}

const ErrorState: React.FC<ErrorStateProps> = ({
  title,
  subtitle,
  onRetry,
}) => {
  const { t } = useTranslation();
  const finalTitle = title ?? t('common.error');
  const finalSubtitle = subtitle ?? t('common.retry');
  return (
    <Result
      status="error"
      title={finalTitle}
      subTitle={finalSubtitle}
      extra={
        onRetry ? (
          <Button type="primary" onClick={onRetry}>
            {t('common.retry')}
          </Button>
        ) : undefined
      }
    />
  );
};

export default ErrorState;
